import { useNavigate, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

type Success = {
	canRender: true;
	hotelID: string;
};

type Failure = {
	canRender: false;
};

type ReturnType = Success | Failure;

export const useConfirmParams = (): ReturnType => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.START_GUIDE_CHECKLIST>>();

	const navigate = useNavigate();

	let canRender = true;

	if (!hotelID) {
		canRender = false;
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);
		throw new Error("hotelID is empty");
	}

	return {
		canRender,
		hotelID,
	};
};
